module.exports = __webpack_public_path__ + "img/1_jeff_h.65e92d92.png";